import React from 'react';
import './index.scss';

const errorMessage = {
  firstName:'Please enter first name',
  lastName:'Please enter last name',
  email:'Please enter a valid email',
  phone:'Please enter a valid phone number'
};

const BasicInfo =  ({info,onChange,onUpdateClick,staffManagement,errors,disableUpdateIfo}) =>{
    console.log('errors',errors);
    return(
        <div className="basicinfo">
            <div className="title">Basic Info</div>
              <div className="input">
                <label className="label">First Name</label>
                <input type="text" defaultValue={info.firstName} onChange={e=>onChange(e,'firstName')} maxlength="100"/>
                {errors.includes('firstName') && <div className="error-message">{errorMessage['firstName']}</div>}
              </div>
              <div className="input">
                <label className="label">Last Name</label>
                <input type="text" defaultValue={info.lastName} onChange={e=>onChange(e,'lastName')} maxlength="100"/>
                {errors.includes('lastName') && <div className="error-message">{errorMessage['lastName']}</div>}
              </div>
              <div className="input">
                <label className="label">Email</label>
                <input type="email" defaultValue={info.email} onChange={e=>onChange(e,'email')} maxlength="100"/>
                {errors.includes('email') && <div className="error-message">{errorMessage['email']}</div>}
              </div>
              <div className="input">
                <label className="label">Phone Number</label>
                <input type="tel" defaultValue={info.phone}  onChange={e=>onChange(e,'phone')} maxlength="100"/>
                {errors.includes('phone') && <div className="error-message">{errorMessage['phone']}</div>}
              </div>
              <div className="actions">
                  <button className="btn btn--primary btn--lg" onClick={onUpdateClick} disabled={staffManagement.updatinginfo||errors.length>0}>
                  {staffManagement.updatinginfo? 'UPDATING...':'UPDATE'}
                  </button>
              </div>
        </div>
    )
}

export default BasicInfo;